import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  checkUserPermissions,
  useOpusPermissions
} from "contexts/authorization/hooks/use-opus-permissions"

interface IRequirePermissionProps {
  children: React.ReactNode
  permissions: string[]
  errorTitle?: string
  errorButtonText?: string
  redirectTo?: string
}

export const RequirePermission: React.FC<IRequirePermissionProps> = ({
  children,
  permissions,
  errorTitle = "You do not have permission to access this page.",
  errorButtonText = "Back to Home",
  redirectTo = "/quotes"
}) => {
  const { permissions: userPermissions } = useOpusPermissions()
  const history = useHistory()

  const hasPermission = checkUserPermissions(permissions, userPermissions)

  useEffect(() => {
    if (userPermissions && !hasPermission) {
      history.replace("/error", {
        status: "403",
        title: errorTitle,
        buttonText: errorButtonText,
        redirectTo
      })
    }
  }, [
    hasPermission,
    userPermissions,
    history,
    errorTitle,
    errorButtonText,
    redirectTo
  ])

  if (!userPermissions) {
    return null
  }

  if (!hasPermission) {
    return null
  }

  return <>{children}</>
}
